module.exports = __webpack_public_path__ + "static/media/shape.c899d4f9.png";